import type { HandlerProps } from '../types.js';
import { Pointer, type PointerHandle } from './pointer/pointer.js';
import { useWiring } from './wiring.js';
import { Canvas } from '@studio/design-system/canvas';
import type { CanvasContext } from '@studio/design-system/canvas';
import type { ReactElement } from 'react';
import { useRef } from 'react';
import { twMerge } from 'cn';

/** `Tool.Zoom` `<Handler>` component. */
export const Handler = ({ className, deviceId, ...props }: HandlerProps): ReactElement => {
  const canvasRef = useRef<CanvasContext>(null);
  const pointerRef = useRef<PointerHandle>(null);
  const wiring = useWiring(deviceId, canvasRef, pointerRef);

  return (
    <>
      <Canvas
        className={twMerge('cursor-none', className)}
        onDraw={wiring.handleDrawCanvas}
        onPointerLeave={wiring.handlePointerEvent}
        onPointerMove={wiring.handlePointerEvent}
        onWheel={wiring.handleWheelEvent}
        ref={canvasRef}
        {...props}
      />
      <Pointer ref={pointerRef} />
    </>
  );
};
